"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ROUTE = void 0;
exports.ROUTE = "chain-updator";
//# sourceMappingURL=constants.js.map